export default async function doBulkDownload(urls: string[]) {
  urls.forEach((url) => {
    // This is a hack to get the browser to download the files without popup blockers triggering
    // A tags wont work as those need the download URL to be the file path
    // which we dont know here, instead lets just launch the page in a hidden iframe
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = url;
    document.body.appendChild(iframe);
    // Remove the iframe once the download has started
    iframe.onload = () => {
      iframe.remove();
    };

    // If the download fails, remove the iframe
    iframe.onerror = () => {
      iframe.remove();
    };
  });
}
